// src/components/Login.js
import React, { useState } from 'react';
import './Login.css';
import betterlandApp from './betterlandApp.webp';

function parseJwt(token) {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch {
    return null;
  }
}

const API_BASE = process.env.REACT_APP_API_URL || '';

// Mapeo de roles para funcionarios y ahora también para admin de electivos
const roleMap = {
  data_manager: 'Data Manager',
  viewer:        'Viewer',
  admin:         'Admin',
  profesor_jefe: 'Profesor Jefe',
  fluidez:       'Fluidez',
  administrador_student_module: 'Electivos Admin',
  estudiante:    'Estudiante'
};

const Login = () => {
  const [loginType, setLoginType] = useState('funcionarios');
  const [username,   setUsername]   = useState('');
  const [password,   setPassword]   = useState('');
  const [error,      setError]      = useState('');

  const handleLogin = async e => {
    e.preventDefault();
    setError('');

    const endpoint = loginType === 'funcionarios'
      ? '/auth/login'
      : '/student/login';

    const payload = loginType === 'funcionarios'
      ? { username, password }
      : { rut: username, password };

    try {
      const res = await fetch(`${API_BASE}${endpoint}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || 'Error en el inicio de sesión');

      const { token } = data;
      const decoded = parseJwt(token) || {};
      localStorage.setItem('token', token);

      if (loginType === 'funcionarios') {
        const storedRole = roleMap[decoded.role] || decoded.role || 'Usuario';
        localStorage.setItem('role', storedRole);
        alert('Inicio de sesión exitoso');
        if (storedRole === 'Profesor Jefe')      window.location.href = '/matricula';
        else if (storedRole === 'Fluidez')       window.location.href = '/resumen-fluidez';
        else if (storedRole === 'Funcionario')    window.location.href = '/mi-perfil';
        else                                      window.location.href = '/dashboard';
      } else {
        // Login de estudiante (incluye admin de electivos si corresponde)
        const storedRole = roleMap[decoded.role] || decoded.role || 'Estudiante';
        localStorage.setItem('role', storedRole);
        alert('Inicio de sesión exitoso');

        if (storedRole === 'Electivos Admin') {
          // Ruta al panel de administración de electivos
          window.location.href = '/electivos-admin';
        } else {
          // Panel normal de estudiante
          window.location.href = '/student/profile';
        }
      }
    } catch (err) {
      console.error('Login error:', err);
      setError(err.message);
    }
  };

  return (
    <div className="login-container">
      <img src={betterlandApp} alt="Betterland App" className="login-header-image" />
      <div className="login-card">
        <div className="login-type-selector">
          <label>
            <input
              type="radio"
              name="loginType"
              value="funcionarios"
              checked={loginType === 'funcionarios'}
              onChange={() => setLoginType('funcionarios')}
            />
            Funcionarios
          </label>
          <label>
            <input
              type="radio"
              name="loginType"
              value="estudiante"
              checked={loginType === 'estudiante'}
              onChange={() => setLoginType('estudiante')}
            />
            Estudiante
          </label>
        </div>

        <h2>
          {loginType === 'funcionarios'
            ? 'Iniciar Sesión Funcionarios'
            : 'Iniciar Sesión Estudiante'}
        </h2>

        <form onSubmit={handleLogin} className="login-form">
          <input
            type="text"
            placeholder={loginType === 'funcionarios' ? 'Usuario' : 'RUT'}
            value={username}
            onChange={e => setUsername(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Contraseña"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
          <button type="submit">Ingresar</button>
        </form>

        {error && <p className="error-message">{error}</p>}
      </div>
    </div>
  );
};

export default Login;
